 <div class="row ss-top-menu">
  <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6">
    <span class="ss-link" style="vertical-align: -webkit-baseline-middle;" [routerLink]="['/']">Dashboard</span> 
    <span style="vertical-align: -webkit-baseline-middle;"><i class="rightArrow fa fa-angle-right"></i> </span>
    <span class="ss-link" style="vertical-align: -webkit-baseline-middle;" [routerLink]="['/community_manager/leads']" [queryParams]="{lead_status: lead_status}" *ngIf="role=='community_manager'">Lead</span>
    <span class="ss-link" style="vertical-align: -webkit-baseline-middle;" [routerLink]="['/designer/leads']" [queryParams]="{customer_status: lead_details.lead_status}" *ngIf="role=='designer'">Lead </span>
    <span *ngIf="lead_details" class="capitalize" style="vertical-align: -webkit-baseline-middle;"><i class="rightArrow fa fa-angle-right"></i> {{lead_details.lead_status | replaceChar}}</span>
    <span style="vertical-align: -webkit-baseline-middle;"><i class="rightArrow fa fa-angle-right"></i> </span>
    <span class="ss-text-dark capitalize" style="vertical-align: -webkit-baseline-middle;" *ngIf="lead_details && lead_details.user_reference">{{lead_details.user_reference.name}}</span>
  </div>
</div>
<div class="rk-ui-notification" *ngIf="successalert">
  <span id="notificationMessageText">{{successMessage}}</span>
  <a class="close rk-linknotification" (click)="successalert=false">×</a>
</div>
<div class="row px-4">
  <app-shared-top-menu [lead_id]='lead_id' [lead_details]='lead_details' [lead_status]='lead_status' [detailed_info_tab]='"active"'></app-shared-top-menu>
  <div class="col-12">
    <div class="row bg-white mb-5">
      <div class="col-md-12 mt-4">
          <div class="phone pull-right">
            <i class="fa fa-phone cursor-pointer" (click)="callToLead(lead_details.id)" style="    font-size: 1.5rem; color: #8F0020;"></i>
          </div>
      </div>
      <div class="col-md-12">
        <ul class="nav nav-tabs tabs-chng mt-4"  id="myTab" role="tablist">
          <li class="nav-item nav-items">
            <a class="nav-link active addCursor text-center mr-3" (click)="getSet('csq')" [ngClass]="{'active': selectedSet == 'csq'}">Questionnaire</a>
          </li>
          <li class="nav-item nav-items" *ngIf="isProjectInWip()">
            <a class="nav-link addCursor text-center mr-3" (click)="getSet('reqsheet')" [ngClass]="{'active': selectedSet == 'reqsheet'}">Requirement Sheet</a>
          </li>
          <li class="nav-item nav-items">
             <a class="nav-link addCursor text-center mr-3" (click)="getSet('scopedoc')" [ngClass]="{'active': selectedSet == 'scopedoc'}">Scope Document</a>
          </li>
          <li class="nav-item nav-items">
             <a class="nav-link addCursor text-center mr-3" (click)="getSet('bookform')" [ngClass]="{'active': selectedSet == 'bookform'}">Booking Form</a>
          </li>

        </ul>

        <div class="csq" *ngIf="this.selectedSet == 'csq'">
          <!-- <p  class="text-center my-5" style="font-size: 18px;" *ngIf="lead_questionnaire == null">No Questionnaire filled for this user</p> -->
          <form [formGroup]="LeadquestionnaireForm" (ngSubmit)="updateRecordNotesQuestionnaire(leadIDForModal,LeadquestionnaireForm.value);">
              <div  class="row question mt-4">
                <div class="col-md-6 mt-3">
                    <label class="customLabel"><strong>Customer Name <span class="text-danger">*</span></strong></label>
                    <input type="text" class="form-control rk-fontsize12" formControlName="customer_name" >
                </div>

                <div class="col-md-6 mt-3" *ngIf="!(role=='designer')">
                  <label class="customLabel"><strong>Customer Phone No <span class="text-danger">*</span></strong></label>
                  <input type="number" class="form-control rk-fontsize12"  formControlName="phone">
                </div>
                <div class="col-md-6 mt-4">
                    <label class="customLabel"><strong>Project Name</strong></label>
                    <input type="text" class="form-control rk-fontsize12" formControlName="project_name" >
                </div>

                <div class="col-md-6 mt-4">
                    <label class="customLabel"><strong>City <span class="text-danger">*</span></strong></label>
                    <div class="form-check">
                    <label class="form-check-label lableSize labelColor mb-2 mr-4 rk-fontsize12 capitalize" *ngFor="let city of citiesForQuestionnaire;">
                      <input class="form-check-input" type="radio" value="{{city.name}}" formControlName="city" (change)="onchangeCity1(city.name)">
                      {{city.name | replaceChar}}
                    </label>
                    <label class="form-check-label lableSize labelColor mb-2 mr-4 rk-fontsize12">
                      <input class="form-check-input" type="radio" value="Other" formControlName="city" (change)="onchangeCity1('Other')">
                      Other <input type="text" name="city_others"  class="form-control d-none rk-fontsize12 ml-2" style="margin-top: -10px; width: 72%;display: inline-block;" [(ngModel)]="city_others" [ngModelOptions]="{standalone: true}" id="cityOthersInput1" >
                    </label>
                  </div>
                </div>
                <div class="col-md-6  mt-4">
                  <div class="form-group">
                    <label class="customLabel">Society/Building Name <span class="text-danger">*</span> </label>
                    <input type="text" class="form-control rk-fontsize12" placeholder="Your answer" formControlName="society">
                  </div>
                </div>
                <div class="col-md-6 mt-4">

                    <label class="customLabel"><strong>Location <span class="text-danger">*</span></strong></label>
                    <input type="text" class="form-control rk-fontsize12" formControlName="location" >
                </div>

                <div class="col-md-6 mt-4">
                    <label class="customLabel"><strong>Project Type <span class="text-danger">*</span></strong></label>
                    <div class="form-check">
                      <label class="form-check-label mr-4 lableSize labelColor mb-2 rk-fontsize12">
                        <input class="form-check-input" type="radio" value="Residential" formControlName="project_type">
                        Residential
                      </label>
                      <label class="form-check-label lableSize labelColor mb-2 mr-4 rk-fontsize12">
                        <input class="form-check-input" type="radio" value="Offices" formControlName="project_type">
                        Offices
                      </label>
                    </div>
                </div>
                <div class="col-md-6 mt-4">
                    <label class="customLabel"><strong>Type of Accommodation <span class="text-danger">*</span></strong> </label>
                    <div class="form-check">
                    <label class="form-check-label lableSize labelColor mr-4 rk-fontsize12" *ngFor="let at of accommodation_type">
                      <input class="form-check-input" type="radio" value="{{at}}" formControlName="accomodation_type">
                      {{at}}
                    </label>
                  </div>
                </div>
                <div class="col-md-6  mt-4">
                  <label class="customLabel"><strong>Type of Home <span class="text-danger">*</span></strong></label>
                  <div class="form-check">
                    <label class="form-check-label lableSize labelColor mb-2 mr-4 rk-fontsize12">
                      <input class="form-check-input" type="radio" value="New (No one has ever stayed in that home)" formControlName="home_type">
                      New (No one has ever stayed in that home)
                    </label>
                    <br>
                    <label class="form-check-label lableSize labelColor mb-2 mr-4 rk-fontsize12">
                      <input class="form-check-input" type="radio" value="Old (Currently staying in the house)" formControlName="home_type">
                      Old (Currently staying in the house)
                    </label>
                  </div>
                </div>


                <div class="col-md-6 mt-4">

                    <label class="customLabel"><strong>Scope of work <span class="text-danger">*</span></strong></label>
                    <br>
                    <!-- <input type="text" class="form-control" value="{{lead_questionnaire.scope_of_work}}" formControlName="scope_of_work" > -->
                    <label class="form-check-label lableSize labelColor mb-2 mr-4 rk-fontsize12" *ngFor="let sw of scopeOfwork">
                      <input type="radio" class="form-check-input" value="{{sw}}" formControlName="scope_of_work">
                      {{sw}}
                      <!-- <input type="checkbox" class="form-check-input" value="{{sw}}" (change)="onCheckChange($event,'scope_of_work')" [checked]="(lead_questionnaire && lead_questionnaire[0] && lead_questionnaire[0]['scope_of_work']!=null && lead_questionnaire[0]['scope_of_work'].indexOf(sw) >=0) || (lead_questionnaire && lead_questionnaire['scope_of_work']!=null && lead_questionnaire['scope_of_work'].indexOf(sw) >=0)"> {{sw}} -->
                    </label>

                </div>
                <div class="col-md-6 mt-4" *ngIf="lead_questionnaire && lead_questionnaire.remarks_of_sow">
                    <label class="customLabel"><strong>Remarks (Scope of work)</strong></label>

                    <input type="text" class="form-control rk-fontsize12" value="{{lead_questionnaire.remarks_of_sow}}" formControlName="scope_of_work" >

                </div>
                <div class="col-md-6 mt-4">
                    <label class="customLabel"><strong>Possession status <span class="text-danger">*</span></strong> </label>
                     <div class="form-check">
                      <label class="form-check-label lableSize labelColor mb-2 mr-4 rk-fontsize12">
                        <input class="form-check-input" type="radio" value="Possession Taken" formControlName="possession_status" (click)="possesionStatusSelected('Possession Taken','updateQuestionnaire')">
                        Possession Taken
                      </label>
                      <label class="form-check-label lableSize labelColor mb-2 mr-4 rk-fontsize12">
                        <input class="form-check-input" type="radio" value="Awaiting Possession" formControlName="possession_status" (click)="possesionStatusSelected('Awaiting Possession','updateQuestionnaire')">
                        Awaiting Possession (If Yes, please fill the date of possession below on "other")
                      </label>
                    </div>
                    <!-- <input type="text" class="form-control" value="{{lead_questionnaire.possession_status}}" formControlName="possession_status" > -->
                </div>
                <div class="col-md-6 mt-4"  id="possesiondateupdate">
                    <!-- <label class="customLabel"><strong>Select Possession Month and Year </strong></label>
                    <input class="form-control" type="text" formControlName="possession_status_date"  value="{{lead_questionnaire.possession_status_date}}"> -->
                    <label class="customLabel">Estimated month of Possession <span class="text-danger">*</span></label>
                    <select formControlName="possession_status_date" class="form-control rk-fontsize12">
                        <option value="" disabled>Choose</option>
                        <option value="{{est}}" *ngFor="let est of estimatedPossessionTime">{{est}}</option>
                    </select>
                </div>

                <div class="col-md-6 mt-4">
                    <label class="customLabel"><strong>Do you have a home loan against the property?</strong> <span class="text-danger">*</span> </label>
                    <div class="form-check">
                      <label class="form-check-label lableSize labelColor mb-2 mr-4 rk-fontsize12">
                        <input class="form-check-input" type="radio" value="Yes" formControlName="have_homeloan">
                        Yes
                      </label>
                      <label class="form-check-label lableSize labelColor mb-2 mr-4 rk-fontsize12">
                        <input class="form-check-input" type="radio" value="No" formControlName="have_homeloan">
                        No
                      </label>
                      <label class="form-check-label lableSize labelColor mb-2 mr-4 rk-fontsize12">
                        <input class="form-check-input" type="radio" value="Doesn't want to disclose" formControlName="have_homeloan">
                        Doesn't want to disclose
                      </label>
                    </div>
                </div>
                <div class="col-md-6 mt-4">
                  <label class="customLabel"><strong>Home Value(In Rs. Lacs)</strong> <span class="text-danger">*</span></label>
                     <select formControlName="home_value" class="form-control rk-fontsize12">
                      <option value="" disabled>Choose</option>
                      <option value="Less than 30 Lacs">Less than 30 Lacs</option>
                      <option value="30 - 50 Lacs">30 - 50 Lacs</option>
                      <option value="50 - 70 Lacs">50 - 70 Lacs</option>
                      <option value="70 - 99 Lacs">70 - 99 Lacs</option>
                      <option value="1 - 1.25 Cr">1 - 1.25 Cr</option>
                      <option value="1.26 - 1.75 Cr">1.26 - 1.75 Cr</option>
                      <option value="1.76 - 2.50 Cr">1.76 - 2.50 Cr</option>
                      <option value="Above 2.50 Cr">Above 2.50 Cr</option>
                      <option value="Not Available">Not Available </option>
                    </select>
                </div>

                <div class="col-md-6 mt-4">
                    <label class="customLabel"><strong>Budget Value(In Rs. Lacs)</strong> <span class="text-danger">*</span></label>
                    <select formControlName="budget_value" class="form-control rk-fontsize12">
                      <option value="" disabled>Choose</option>
                      <option value="Less than 1.5 Lac">Less than 1.5 Lac</option>
                      <option value="1.5 - 3 Lacs">1.5 - 3 Lacs</option>
                      <option value="3 - 5 Lacs">3 - 5 Lacs</option>
                      <option value="5 - 8 Lacs">5 - 8 Lacs</option>
                      <option value="8 - 12 Lacs">8 - 12 Lacs</option>
                      <option value="Above 12 Lacs">Above 12 Lacs</option>
                      <option value="Not Disclosed">Not Disclosed</option>
                    </select>
                </div>

                <div class="col-md-6 mt-4">

                    <label class="customLabel"><strong>Call Back Day <span class="text-danger">*</span></strong> </label>
                    <input type="date" class="form-control rk-fontsize12"  formControlName="call_back_day" >
                </div>
                <div class="col-md-6 mt-4">
                    <label class="customLabel"><strong>Call Back Time</strong> </label>
                    <div class="form-check">
                      <select formControlName="call_back_time" class="form-control rk-fontsize12">
                        <option value="" disabled>Choose</option>
                        <option value="{{cb}}" *ngFor="let cb of callbacktime">{{cb}}</option>
                      </select>
                    </div>
                </div>
                <div class="col-sm-6 mt-2">
                    <div class="form-group">
                     <label class="customLabel">Lead Generator</label>
                      <select formControlName="lead_generator" class="form-control rk-fontsize12">
                        <option value="" disabled>Choose</option>
                        <option value="Akshay Pawar">Akshay Pawar</option>
                        <option value="Azhar Khan">Azhar Khan</option>
                        <option value="Rohit Dalvi">Rohit Dalvi</option>
                        <option value="Roshni Malik">Roshni Malik</option>
                        <option value="Roshan">Roshan</option>
                      </select>
                    </div>
                </div>
                <div class="col-sm-6 mt-2">
                  <div class="form-group">
                    <label class="customLabel">Lead Source</label>
                    <select formControlName="lead_source" class="form-control rk-fontsize12">
                      <option value="" disabled>Choose</option>
                      <option value="Facebook Campaign">Facebook Campaign</option>
                      <option value="Inbound Call">Inbound Call</option>
                      <option value="Housing Finance">Housing Finance</option>
                      <option value="Facebook Direct">Facebook Direct</option>
                      <option value="Get a callback from us">Get a callback from us</option>
                      <option value="Broker">Broker</option>
                      <option value="Referral">Referral</option>
                      <option value="Dealer">Dealer</option>
                    </select>
                  </div>

                </div>

                
              
                <div class="col-md-6 mt-4">
                    <label class="customLabel"><strong>Do you have a floor plan?</strong> </label>
                    <div class="form-check">
                      <label class="form-check-label lableSize labelColor mb-2 mr-4 rk-fontsize12">
                        <input class="form-check-input" type="radio" value="Yes" formControlName="have_floorplan" (click)="fpQuestionnaireSelected('yes','floorplanQuestionnaire')">
                        Yes
                      </label>
                      <label class="form-check-label lableSize labelColor mb-2 mr-4 rk-fontsize12">
                        <input class="form-check-input" type="radio" value="No" formControlName="have_floorplan" (click)="fpQuestionnaireSelected('no','floorplanQuestionnaire')">
                        No
                      </label>
                    </div>
                </div>
                <div class="col-sm-12 col-md-12 mt-3" id="floorplanQuestionnaire" style="display: none;">
                  <label class="customLabel">Upload Floorplan</label>
                  <div class="form-check">
                    <input class="form-control rk-fontsize12" type="file" (change)="onQuestionnaireFloorplanChange($event)" name="floorplan_attachment_file" ngModel #floorplan_attachment_file="ngModel" [ngModelOptions]="{standalone: true}">
                  </div>
                  <p id="extErrorMsg" class="text-danger d-none col-sm-10 rk-fontsize12">Check File extension (File should be in proper image format).</p>
                  <p class="col-sm-10 rk-fontsize12">Note* - only image files are allowed.  </p>
                </div>
                
                <div class="col-md-6 mt-4" *ngIf="lead_questionnaire!=0 && lead_questionnaire && LeadquestionnaireForm.controls['lead_floorplan'].value != '/images/original/missing.png' && LeadquestionnaireForm.controls['have_floorplan'].value=='Yes' ">
                    <label class="customLabel"><strong>Uploaded Floorplan</strong> </label><br>
                    <a href="{{LeadquestionnaireForm.controls['lead_floorplan'].value}}" target="_blank"  style="color: #007bff">View Floorplan </a>
                </div>

                <div class="col-md-6 mt-4" *ngIf="LeadquestionnaireForm.controls['lead_floorplan'].value == '/images/original/missing.png' && LeadquestionnaireForm.controls['have_floorplan'].value=='Yes' && lead_questionnaire ">
                    <label class="customLabel"><strong>Uploaded Floorplan</strong> </label><br>
                    <span class="text-danger rk-fontsize12">Floorplan not available </span>
                </div>
                <div class="col-md-6 mt-4">
                    <label class="customLabel"><strong>Additional Comments:</strong> </label>
                    <textarea rows="2" class="form-control rk-fontsize12" formControlName="additional_comments"></textarea>
                    <!-- <input type="text" class="form-control"  formControlName="additional_comments" > -->
                </div>
                <div class="col-md-6 mt-4">
                    <label class="customLabel"><strong>CM Comments:</strong> </label>
                    <textarea rows="2" class="form-control rk-fontsize12" formControlName="cm_comments"></textarea>
                    <!-- <input type="text" class="form-control"  formControlName="additional_comments" > -->
                </div>
                <div class="col-md-6 mt-4">
                    <label class="customLabel"><strong>Designer Comments:</strong> </label>
                    <textarea rows="2" class="form-control rk-fontsize12" formControlName="designer_comments"></textarea>
                    <!-- <input type="text" class="form-control"  formControlName="additional_comments" > -->
                </div>
              </div>
              <!-- <pre>{{LeadquestionnaireForm.value | json}}</pre> -->
               <button class="btn my-3 rk-interalBtnColor pull-right addCursor" type="submit" [disabled]="!LeadquestionnaireForm.valid || (LeadquestionnaireForm.valid && LeadquestionnaireForm.controls['city'].value=='Other' && (city_others=='' ||city_others==undefined))" >Update</button>

          </form>
        </div>

        <div class="reqsheet" *ngIf="this.selectedSet == 'reqsheet'">
          <app-requirement-sheet></app-requirement-sheet>
        </div>

        <div class="scopedoc" *ngIf="this.selectedSet == 'scopedoc'">
          <app-scope-document></app-scope-document>
        </div>

        <div class="bookform" *ngIf="this.selectedSet == 'bookform'">
          <app-booking-form></app-booking-form>
        </div>

        <div class="bf_2" *ngIf="this.selectedSet == 'bf_2'">
          <form [formGroup]="designerBookingForm1" (ngSubmit)="designerBookingForm1Submit(designerBookingForm1.value,'bookingForm2')">
            <div  class="row question mt-4">
              <div class="col-md-6 mt-3">
                  <label class="customLabel"><strong>Customer Name </strong></label>
                  <input type="text" class="form-control" placeholder="{{customerDetails.name}}" readonly formControlName="customer_name">
              </div>
              <div class="col-md-6 mt-3">
                  <label class="customLabel"><strong>Customer Age </strong></label>
                <input type="text" class="form-control" placeholder="" formControlName="customer_age">
              </div>
              <div class="col-md-12 mt-4">
                  <label class="customLabel"><strong>Profession / Background of the Client </strong></label>
                  <input type="text" class="form-control" placeholder="" formControlName="profession">
              </div>

              <div class="col-md-12 mt-4">
                  <label class="customLabel"><strong>Family Background of members staying in the house </strong></label>
                  <input type="text" class="form-control" placeholder="" formControlName="family_profession">
              </div>
              <div class="col-md-12 mt-4">
                  <label class="customLabel"><strong>How old is the kitchen</strong></label>
                  <input type="text" class="form-control" placeholder="" formControlName="mk_age">
              </div>

              <div class="col-md-12 mt-4">
                  <label class="customLabel"><strong>Lifestyle of the members staying in the house</strong></label>
                  <input type="text" class="form-control" placeholder="" formControlName="mk_lifestyle">
              </div>
              <div class="col-md-12 mt-4">
                  <label class="customLabel"><strong>Are they planning to gut the kitchen area</strong> </label>
                  <input type="text" class="form-control" placeholder="" formControlName="mk_gut_kitchen">
              </div>
              <div class="col-md-12 mt-4">
                  <label class="customLabel"><strong>Are they planning to keep the same layout & simply make cosmetic changes</strong></label>
                  <input type="text" class="form-control" formControlName="mk_same_layout">
              </div>
              <div class="col-md-12 mt-4">
                  <label class="customLabel"><strong>What kind of improvements are they looking for in a new kitchen (Upgraded electrical service, Better lighting, Additional storage space. ) </strong></label>
                  <input type="text" class="form-control" formControlName="mk_improvements">
              </div>
              <div class="col-md-12 mt-4">
                  <label class="customLabel"><strong>Some special requirements in a new kitchen?</strong> </label>
                  <input type="text" class="form-control" formControlName="mk_special_requirements">
              </div>
              <div class="col-md-12 mt-4">
                <label class="customLabel"><strong>Who is the primary cook? And what kind of cooking they have on a regular basis (Veg / Non Veg) </strong></label>
                <input class="form-control" type="text" formControlName="mk_cooking_details">
              </div>
              <div class="col-md-12 mt-4">
                  <label class="customLabel"><strong>List of appliances/white goods/smaller electrical appliances(Microwave / Oven / Mixie)</strong> </label>
                  <input type="text" class="form-control" formControlName="mk_appliances">
              </div>
              <div class="col-md-12 mt-4">
                <label class="customLabel"><strong> What is the family eating area as in  like kitchen area, dining table, counter space?</strong></label>
                  <input type="text" class="form-control" formControlName="mk_family_eating_area">
              </div>
              <div class="col-md-12 mt-4">
                  <label class="customLabel"><strong>How often do they entertain guests?</strong> </label>
                  <input type="text" class="form-control" formControlName="mk_guest_frequence">
              </div>
              <div class="col-md-12 mt-4">
                  <label class="customLabel"><strong>Storage patterns like monthly, yearly, as required basis?</strong> </label>
                  <input type="text" class="form-control" formControlName="mk_storage_patterns">
              </div>
              <div class="col-md-12 mt-4">
                  <label class="customLabel"><strong>What kind of cabinets facing they are looking at (Glossy / Matt)</strong> </label>
                  <input type="text" class="form-control" formControlName="mk_cabinet_finishing">
              </div>
              <div class="col-md-12 mt-4">
                  <label class="customLabel"><strong>Counter top material/backsplash materials to be discussed</strong> </label>
                  <input type="text" class="form-control" formControlName="mk_countertop_materials">
              </div>
              <div class="col-md-12 mt-4">
                  <label class="customLabel"><strong>Any colour/mood for the look preferred?</strong> </label>
                  <input type="text" class="form-control" formControlName="mk_mood">
              </div> 
            </div>
            <div class="row">
              <div class="col-md-12 mt-4">
                <button class="btn btn-pink pull-right" id="designerBookingForm2Button">SUBMIT</button>
               
              </div>
            </div>
          </form>
        </div>

      </div>
    </div>
  </div>
</div>


// WEBPACK FOOTER //
// /Users/shobhit/Documents/codes/arrivae-frontend/src/app/platform/lead/detailed-info/detailed-info.component.html